export default __webpack_public_path__ + "static/media/SWT0190.34I-27410_-16472_0.cd71f273.jpg";